module.exports = __webpack_public_path__ + "static/googleStoreImage.7a60f99f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/googleStoreImage.png
// module id = 102
// module chunks = 35783957827783 195254786234044